import {messages} from '@smartmixin/i18n';
import {
  Broadcast,
  CloudSun,
  CreditCard,
  Link as LinkIcon,
  Question,
  RocketLaunch,
  UserCircle,
} from '@phosphor-icons/react';
import {MessageDescriptor} from 'react-intl';

export const CATEGORY_ORDER = [
  'getting-started',
  'account',
  'stations',
  'forecast',
  'providers',
  'billing',
  'troubleshooting',
];

export const CATEGORY_MESSAGES: Record<string, MessageDescriptor> = {
  'getting-started': messages.helpCenter.helpCategoryGettingStarted,
  account: messages.helpCenter.helpCategoryAccount,
  stations: messages.helpCenter.helpCategoryStations,
  forecast: messages.helpCenter.helpCategoryForecast,
  providers: messages.helpCenter.helpCategoryProviders,
  billing: messages.helpCenter.helpCategoryBilling,
  troubleshooting: messages.helpCenter.helpCategoryTroubleshooting,
};

// Drawn in text.secondary: a category is told apart by its name and icon,
// not by a hue (the per-category colours were literals outside the roles).
export const CATEGORY_ICONS: Record<string, React.ElementType> = {
  'getting-started': RocketLaunch,
  account: UserCircle,
  stations: Broadcast,
  forecast: CloudSun,
  providers: LinkIcon,
  billing: CreditCard,
  troubleshooting: Question,
};

// Curated top support drivers shown on the help center landing page.
// Revisit against support-inbox stats when the mix of questions shifts.
export const POPULAR_ARTICLE_SLUGS = [
  'getting-started',
  'connecting-station',
  'troubleshooting-common-issues',
  'managing-subscription',
];

// The titles articles give their own closing "related articles" section, in
// every content locale (the UI label is not what authors always wrote: fr has
// "Articles connexes", "Articles liés" and "Articles associés"). An article
// carrying one of these as an h2 gets no second, generated list. Compared
// lower-cased.
export const RELATED_SECTION_TITLES = [
  'related articles',
  'articles connexes',
  'articles liés',
  'articles associés',
  'verwandte artikel',
  'articoli correlati',
  'artículos relacionados',
];

export const SUPPORT_EMAIL = 'contact@smartmixin.io';

// Stable id so the Cmd/Ctrl+K shortcut can focus whichever search input is
// on the current help page.
export const HELP_SEARCH_INPUT_ID = 'help-center-search-input';

// Estimate reading time based on word count
export const getReadingTime = (content: string): number => {
  const wordsPerMinute = 200;
  const wordCount = content.split(/\s+/).length;
  return Math.max(1, Math.ceil(wordCount / wordsPerMinute));
};
